import { Form } from "react-bootstrap";
import { CrudSelectModel } from "./crudInputModel";
import { RequiredAsterisks } from "../../Asterisks/requiredAsterisks";
import { ReactSelectOptionType } from "../../../../../../shared/types/reactSelectType";
import Select from "react-select";

export const CrudSelectInput = ({
  validationSchema,
  form,
  name,
  label,
  disabled,
  t,
  required,
  selectOption,
  isMulti,
}: CrudSelectModel) => {
  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        let value = null;

        if (field.state.value != undefined) {
          value = isMulti
            ? selectOption?.filter(({ value }) =>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                field.state.value.includes(parseInt(value + "")),
              ) || []
            : selectOption?.filter(({ value }) =>
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                field.state.value.includes(value),
              ) || null;
        }

        return (
          <Form.Group className="mb-3">
            <Form.Label>
              {label} {required && <RequiredAsterisks />}
            </Form.Label>
            <Select
              id={field.name}
              key={field.name}
              name={field.name}
              value={value}
              onBlur={field.handleBlur}
              noOptionsMessage={() => {
                return t("No options");
              }}
              onChange={(options: unknown) => {
                if (isMulti) {
                  const selectedOptions = options as ReactSelectOptionType[];

                  field.handleChange(
                    selectedOptions.map((option) => {
                      return parseInt(option.value);
                    }),
                  );

                  return;
                }
                const selectedOption = options as ReactSelectOptionType;
                field.handleChange(selectedOption.value);
              }}
              isDisabled={disabled}
              isMulti={isMulti}
              options={selectOption}
            ></Select>
            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
